<template>
  <el-form-item :label="i18nt('designer.setting.inactiveValue')">
    <el-input v-model="inactiveValue"></el-input>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'inactiveValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    return {
      i18nt,
      ...toRefs(props),
    };
  },
};
</script>

<style scoped></style>
